import { PhotoExports } from '../../../cimsPage/instances/importsExports'
import { Simple } from '../../common'

export const CreatePhotoExportRequest = Simple({
  id: '4bb0d0bd-bac2-4da8-9efb-e052cedba991',
  action: 'Create',
  object: 'Photo Export',
  page: PhotoExports,
})
